export default [
  {
    id: 'stock_level',
    title: 'Stock Levels',
    link: '/stock-levels',
    color: '#F1FF00',
    icon: 'view_in_ar',
    priv: 'VIEW_STOCK_LEVELS'
  },
  {
    id: 'processes',
    title: 'Service Forms',
    link: '/processes',
    color: '#F1FF00',
    icon: 'view_in_ar',
    priv: 'VIEW_SERVICE_FORMS'
  },
  {
			id: 'quote_status',
			title: 'Quote Statuses',
			link: '/quote-status',
			color: '#F1FF00',
			icon: 'access_time',
			priv: 'VIEW_QUOTE_STATUSES'
		},

	    {
		    id: 'notifications',
		    title: 'Notifications',
		    link: '/notifications',
		    icon: 'add_alert',
		    priv: 'NOTIFICATION_MODULE'
	    },
		{
			id: 'reports',
			title: 'Reports',
			link: '#',
			color: '#5383FF',
			icon: 'show_chart',
			priv: 'All',
			children: [
				{
					id: 'quote-report',
					title: 'Quote Report',
					link: '/reports/quote-reports?p=1',
					priv: 'VIEW_QUOTES'
				},
        {
          id: 'quote-report-lite',
          title: 'Quote Bolt',
          link: '/reports/quote-reports-lite?p=1',
          priv: 'VIEW_QUOTES'
        },
        {
          id: 'quote-report',
          title: 'Quote Report',
          link: '/reports/quote-reports?p=1',
          priv: 'VENDOR_SHOW_QUOTE_REPORT'
        },
				{
					id: 'spec-report',
					title: 'Spec Report',
					link: '/reports/spec-reports',
					priv: 'SPEC_MODULE'
				},
				/*{
					id: 'tender-report',
					title: 'Tender Report',
					link: '/reports/tender-reports',
					priv: 'TENDER_MODULE'
				},*/
				{
					id: 'product-sales-report',
					title: 'Product Sales Report',
					link: '/reports/product-sales-reports',
					priv: 'PS_MODULE'
				},
                {
                    id: 'rfc-report',
                    title: 'RFC',
                    link: '/reports/rfc-reports',
					priv: 'RFC_REPORT'
                },
                {
                    id: 'discount-request-report',
                    title: 'Discount Request Report',
                    link: '/reports/discount-request-reports',
					priv: 'DISCOUNT_REQUEST_REPORT'
				},
				{
					id: 'sales-order-report',
					title: 'Purchase Order Report',
					link: '/reports/sales-order-reports',
					priv: 'VENDOR_REPORT'
				}
			]
		},
		{
			id: 'users',
			title: 'Users',
			link: '#',
			color: '#2BF879',
			icon: 'supervisor_account',
			priv: 'VIEW_USERS',
			children: [
				{
					id: 'reps',
					title: '[REPS]',
                    link: '/users/reps',
					priv: 'VIEW_USERS'
				},
				{
					id: 'customer-users',
					title: '[CUSTOMERS]',
					link: '/users/customer-users',
					priv: 'VIEW_USERS',
					priv_not: 'HIDE_CUSTOMER_USERS'
				},
				{
					id: 'spesific-users',
					title: '[SPECIFIER]',
					link: '/users/specific-users',
					priv: 'VIEW_USERS',
					priv_not: 'HIDE_SPECIFIER_USERS'
				},
				{
					id: 'public-users',
					title: '[PUBLIC]',
					link: '/users/public-users',
					priv: 'VIEW_USERS',
					priv_not: 'HIDE_PUBLIC_USERS'
				},
				{
					id: 'vendor-users',
					title: '[VENDOR]',
					link: '/users/vendor-users',
					priv: 'VIEW_USERS',
					priv_not: 'HIDE_VENDOR_USERS'
				}
			]
		},
		{
			id: 'branches',
			title: 'Stores',
			link: '/branches',
			color: '#F1FF00',
			icon: 'account_tree',
			priv: 'BRANCH_MODULE'
		},
		{
			id: 'departments',
			title: 'Departments',
			link: '/departments',
			color: '#AE0A1A',
			icon: 'line_style',
			priv: 'DEPARTMENTAL_MODULE'
		},
		/*{
			id: 'vendors',
			title: 'Vendors',
			link: '/vendors',
			color: '#999999',
			icon: 'receipt',
			priv: 'VENDOR_MODULE'
		},*/
		/*{
			id: 'vendor-assign',
			title: 'Vendor Assign',
			link: '/vendor-assign',
			color: '#999999',
			icon: 'receipt',
			priv: 'VENDOR_MODULE'
		},*/
		{
			id: 'projects',
			title: 'Projects',
			link: '/projects',
			color: '#A528AE',
			icon: 'business',
			priv: 'VIEW_PROJECTS'
		},
		{
			id: 'project_status',
			title: 'Project Status',
			link: '/project-status',
			color: '#F1FF00',
			icon: 'autorenew',
			priv: 'VIEW_PROJECT_STATUSES'
		},
		{
			id: 'spec_status',
			title: 'Spec Status',
			link: '/spec-status',
			color: '#F1FF00',
			icon: 'autorenew',
			priv: 'SPEC_MODULE'
		},
		{
			id: 'pricelists',
			title: 'Pricelists',
			link: '/pricelists',
			color: '#AE0A1A',
			icon: 'attach_money',
			priv: 'VIEW_PRICELISTS'
		},
		{
			id: 'regions',
			title: 'Regions',
			link: '/regions',
			color: '#51F808',
			icon: 'location_on',
			priv: 'VIEW_REGIONS'
		},
		{
			id: 'roles',
			title: 'Roles',
			link: '/roles',
			color: '#06FCE1',
			icon: 'work',
			priv: 'VIEW_ROLES'
		},
		{
			id: 'privileges',
			title: 'Privileges',
			link: '/privileges',
			color: 'orange',
			icon: 'code',
			priv: 'VIEW_PRIVILEGES'
		},
		{
			id: 'rfc_status',
			title: 'RFC Status',
			link: '/rfc-status',
			color: '#F1FF00',
			icon: 'access_time',
			priv: 'RFC_REPORT'
		},
		{
			id: 'transport',
			title: 'Transport',
			link: '#',
			color: '#BC9D2D',
			icon: 'local_shipping',
			children: [
				{
					id: 'packages',
					title: 'Packages',
					link: '/transport/packages',
					priv: 'TRANSPORT_MODULE'
				},
				{
					id: 'vehicles',
					title: 'Vehicles',
					link: '/transport/vehicles',
					priv: 'TRANSPORT_MODULE'
				},
				{
					id: 'transport-cost-matrix',
					title: 'Transport Cost Matrix',
					link: '/transport/cost-matrix',
					priv: 'TRANSPORT_MODULE'
				},
				{
					id: 'factories',
					title: 'Factories',
					link: '/transport/factories',
					priv: 'TRANSPORT_MODULE'
				},
				{
					id: 'product-configuration',
					title: 'Product Configuration',
					link: '/transport/product-configuration',
					priv: 'TRANSPORT_MODULE'
				},
			],
			priv: 'TRANSPORT_MODULE'
		},
		{
			id: 'installation_cost',
			title: 'Installation Cost',
			link: '/installation-costs',
			color: '#F1FF00',
			icon: 'attach_money',
			priv: 'INSTALLATION_COSTS'
		}
	]

